import { render, staticRenderFns } from "./CropperImage.vue?vue&type=template&id=16665b08&"
import script from "./CropperImage.vue?vue&type=script&lang=js&"
export * from "./CropperImage.vue?vue&type=script&lang=js&"
import style0 from "./CropperImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VCard,VDialog,VSlider})
